import { MedicalRecordRequest } from "#/api/medical-record-requests.type";
import { formatPhoneNumberToHumanReadable } from "#/components/utls/utils";
import { extractContractFormValues } from "#/lib/contractFormValues";

type DetailEntry = {
  label: string;
  value: string | null;
  href?: string | null;
};

function formatYesNo(value?: boolean | null) {
  if (value === undefined || value === null) return null;
  return value ? "Yes" : "No";
}

export function buildDetails(request?: MedicalRecordRequest | null) {
  if (!request) return [];
  const formValues = extractContractFormValues(
    request as unknown as Record<string, any>
  );
  const normalizedPatientId =
    request.patientId ??
    formValues?.patient_id ??
    formValues?.patientId ??
    null;
  const normalizedPatientName =
    request.patientName ??
    request.patient_name ??
    formValues?.patient_full_name ??
    formValues?.patientFullName ??
    formValues?.patient_name ??
    formValues?.patientName ??
    null;
  const normalizedFax = request.faxNumber ?? request.fax_number ?? null;
  const pdfUrl = request.pdfUrl ?? null;
  const hasSignatureImage = request.hasSignatureImage ?? null;
  const entries: DetailEntry[] = [
    { label: "Request ID", value: request.id },
    { label: "Status", value: request.status },
    { label: "Patient ID", value: normalizedPatientId ?? null },
    {
      label: "Patient Name",
      value: normalizedPatientName,
    },
    { label: "Created", value: new Date(request.createdAt).toLocaleString() },
    {
      label: "Delivery Method",
      value: request.deliveryMethod ?? request.delivery_method ?? null,
    },
    {
      label: "Institution",
      value: request.recipientName ?? request.recipient_name ?? null,
    },
    {
      label: "Recipient Type",
      value: request.recipientType ?? request.recipient_type ?? null,
    },
    {
      label: "Recipient External ID",
      value:
        request.recipientExternalId ?? request.recipient_external_id ?? null,
    },
    {
      label: "Fax Number",
      value: normalizedFax
        ? formatPhoneNumberToHumanReadable(normalizedFax)
        : null,
    },
    {
      label: "Email Address",
      value: request.emailAddress ?? request.email_address ?? null,
    },
    {
      label: "Signature Image",
      value: formatYesNo(hasSignatureImage),
    },
    {
      label: "PDF",
      value: pdfUrl ? "View PDF" : "Not uploaded",
      href: pdfUrl,
    },
  ];

  return entries;
}

export type { DetailEntry };
